import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client } from '../common';
import type { Checkin } from '../reservations';

type Variables = {
  reservationId: number;
};

export const useCreateCheckin = createMutation<Checkin, Variables, AxiosError>({
  mutationFn: async (variables) =>
    client({
      url: `v2/checkins?reservation_id=${variables.reservationId}`,
      method: 'POST',
    })
      .then((response) => response.data)
      .catch((err: any) => {
        throw new Error(err.response.data.error);
      }),
});
